// @flow

import { FoxfordService } from '../services/foxford'

export type FastdevDataMetabase = {
  [key: string]: any,
  attachments_attributes?: Array<{ name: string, file: any }>,
}

/**
 * Добавляет массив объектов с файлами в FormData
 * @param formData
 * @param files
 */
const attachFilesToFormData = (formData: FormData, files: Array<{ name: string, file: any }>) => {
  for (const [index, file] of files.entries()) {
    for (const key in file) {
      formData.append(`submission[attachments_attributes][${index}][${key}]`, file[key])
    }
  }
}

/**
 * Подготавливает данные для отправки в метабазу
 * В зависимости от того, есть ли файлы для отправки возвращает объект или FormData с данными
 * @param data
 * @return {{submission: FastdevDataMetabase}|FormData}
 */
const prepareDataForSend = (data: FastdevDataMetabase) => {
  const hasAttachment = data?.attachments_attributes !== undefined
  if (hasAttachment) {
    const body = new FormData()

    for (const [key, value] of Object.entries(data)) {
      if (key === 'attachments_attributes' && data.attachments_attributes) {
        attachFilesToFormData(body, data.attachments_attributes)
      } else {
        //$FlowFixMe
        body.append(`submission[${key}]`, value)
      }
    }

    return body
  }

  return {
    submission: data,
  }
}

export const sendDataToMetabase = async (
  slug: string,
  data: FastdevDataMetabase
): Promise<{ status: number, error?: string }> => {
  try {
    const hasAttachment = data?.attachments_attributes !== undefined
    const contentType = hasAttachment ? 'multipart/form-data' : 'application/json'
    const dataForSend = prepareDataForSend(data)

    const request = await FoxfordService.api.post(`/api/fastdev/projects/${slug}/submission`, dataForSend, {
      headers: {
        'Content-type': contentType,
      },
    })

    return { status: request.status }
  } catch (e) {
    return { status: e.status, error: e.errors ? e.errors : e.messages[0] }
  }
}
